import { createMainResourceREST } from '../resource';
import {
  CRPreferredFittingBody,
  CRPreferredFittingBodyAPI,
  CRPreferredFittingKey,
  CRPreferredFittingSummary,
  CRPreferredFittingSummaryAPI,
  PreferredFittingsActions,
  PreferredFittingsState,
} from './types';

type AnyPreferredFitting =
  | CRPreferredFittingKey
  | CRPreferredFittingSummary
  | CRPreferredFittingBody
  | undefined;

function sameKeyPreferredFitting(
  a: AnyPreferredFitting,
  b: AnyPreferredFitting,
): boolean {
  return a?.categoryId === b?.categoryId;
}

function getEndpointPreferredFitting(key: AnyPreferredFitting): string {
  return key
    ? `/preferred-fittings/${key.categoryId}/`
    : '/preferred-fittings/';
}

function parsePreferredFittingSummary(
  preferredFittingSummary: CRPreferredFittingSummaryAPI,
): CRPreferredFittingSummary {
  return preferredFittingSummary;
}

function parsePreferredFittingBody(
  preferredFittingDetail: CRPreferredFittingBodyAPI,
): CRPreferredFittingBody {
  return preferredFittingDetail;
}

const preferredFittingsStateSelector = (state: any): PreferredFittingsState =>
  state.preferredFittings;

const preferredFittingsKeySelector = ({
  categoryId,
}:
  | CRPreferredFittingBody
  | CRPreferredFittingSummary): CRPreferredFittingKey => ({
  categoryId,
});

function mergePreferredFittingBody(
  lastBody: CRPreferredFittingBody,
  currentBody: CRPreferredFittingBody,
) {
  return currentBody;
}

function combineSummaryBodyPreferredFitting(
  summary?: CRPreferredFittingSummary,
): CRPreferredFittingSummary {
  return {
    ...summary!,
  };
}

const { actions, reducer, watches } = createMainResourceREST(
  'preferredFittings',
  getEndpointPreferredFitting,
  preferredFittingsStateSelector,
  sameKeyPreferredFitting,
  parsePreferredFittingBody,
  parsePreferredFittingSummary,
  mergePreferredFittingBody,
  combineSummaryBodyPreferredFitting,
);

const preferredFittingsActions: PreferredFittingsActions = actions;

export * from './types';

export {
  preferredFittingsActions,
  reducer as preferredFittingsReducer,
  watches as preferredFittingsWatches,
  preferredFittingsStateSelector,
  preferredFittingsKeySelector,
};
